"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var message_1 = require("./message");
var formats_1 = __importDefault(require("./formats"));
var rules_1 = __importDefault(require("./rules"));
var ValidatorRules = {};
var ValidatorFormators = {};
var template = function (message, context) {
    if (shared_1.isStr(message)) {
        if (shared_1.isFn(FormValidator.template)) {
            return FormValidator.template(message, context);
        }
        return message.replace(/\{\{\s*([\w.]+)\s*\}\}/g, function (_, $0) {
            return shared_1.FormPath.getIn(context, $0);
        });
    }
    else if (shared_1.isObj(message) && !message['$$typeof'] && !message['_owner']) {
        return template(message.message, context);
    }
    else {
        return message;
    }
};
var FormValidator = (function () {
    function FormValidator(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.validate = function (path, options) {
            var pattern = shared_1.FormPath.getPath(path || '*');
            return _this.validateNodes(pattern, options);
        };
        this.register = function (path, calculator) {
            var newPath = shared_1.FormPath.getPath(path);
            _this.nodes[newPath.toString()] = function (options) {
                return new Promise(function (resolve, reject) {
                    var tmpResult;
                    var validate = function (value, rules) { return __awaiter(_this, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            data = __assign(__assign({}, options), { key: newPath.toString() });
                            return [2, this.internalValidate(value, this.transformRules(rules), data).then(function (payload) {
                                    tmpResult = payload;
                                    return payload;
                                }, function (payload) {
                                    tmpResult = payload;
                                    return Promise.reject(payload);
                                })];
                        });
                    }); };
                    Promise.resolve(calculator(validate)).then(function () {
                        resolve(tmpResult);
                    }, function () {
                        reject(tmpResult);
                    });
                });
            };
        };
        this.unregister = function (path) {
            var newPath = shared_1.FormPath.getPath(path);
            delete _this.nodes[newPath.toString()];
        };
        this.validateFirst = options.validateFirst;
        this.matchStrategy = options.matchStrategy;
        this.nodes = {};
    }
    FormValidator.prototype.transformRules = function (rules) {
        var _this = this;
        if (shared_1.isStr(rules)) {
            if (!ValidatorFormators[rules]) {
                throw new Error('Can not found validator pattern');
            }
            return [
                {
                    pattern: ValidatorFormators[rules],
                    message: message_1.getMessage(rules) || 'Can not found validator message.'
                }
            ];
        }
        else if (shared_1.isFn(rules)) {
            return [
                {
                    validator: rules
                }
            ];
        }
        else if (shared_1.isArr(rules)) {
            return rules.reduce(function (buf, rule) {
                return buf.concat(_this.transformRules(rule));
            }, []);
        }
        else if (shared_1.isObj(rules)) {
            if (rules.format) {
                if (!ValidatorFormators[rules.format]) {
                    throw new Error('Can not found validator pattern');
                }
                rules.pattern = ValidatorFormators[rules.format];
                rules.message = rules.message || message_1.getMessage(rules.format);
            }
            return [rules];
        }
        return [];
    };
    FormValidator.prototype.internalValidate = function (value, rules, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var first, errors, warnings, i, ruleObj, keys, l, key, rule, payload, message, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        first = shared_1.isValid(options.first)
                            ? !!options.first
                            : !!this.validateFirst;
                        errors = [];
                        warnings = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < rules.length)) return [3, 7];
                        ruleObj = rules[i];
                        keys = Object.keys(ruleObj).sort(function (key) {
                            return key === 'validator' ? 1 : -1;
                        });
                        l = 0;
                        _a.label = 3;
                    case 3:
                        if (!(l < keys.length)) return [3, 6];
                        key = keys[l];
                        if (!(ruleObj.hasOwnProperty(key) && shared_1.isValid(ruleObj[key]))) return [3, 5];
                        rule = ValidatorRules[key];
                        if (!rule) return [3, 5];
                        return [4, rule(value, ruleObj, ValidatorRules)];
                    case 4:
                        payload = _a.sent();
                        message = template(payload, __assign(__assign({}, ruleObj), { rule: ruleObj, value: value }));
                        if (shared_1.isStr(payload) ||
                            (payload['$$typeof'] && payload['_owner'])) {
                            if (first) {
                                if (message) {
                                    errors.push(message);
                                    throw new Error(message);
                                }
                            }
                            if (message)
                                errors.push(message);
                        }
                        else if (shared_1.isObj(payload)) {
                            if (payload.type === 'warning') {
                                if (message)
                                    warnings.push(message);
                            }
                            else {
                                if (first) {
                                    if (message) {
                                        errors.push(message);
                                        throw new Error(message);
                                    }
                                }
                                if (message)
                                    errors.push(message);
                            }
                        }
                        _a.label = 5;
                    case 5:
                        l++;
                        return [3, 3];
                    case 6:
                        i++;
                        return [3, 2];
                    case 7: return [2, {
                            errors: errors,
                            warnings: warnings
                        }];
                    case 8:
                        e_1 = _a.sent();
                        return [2, {
                                errors: errors,
                                warnings: warnings
                            }];
                    case 9: return [2];
                }
            });
        });
    };
    FormValidator.prototype.validateNodes = function (pattern, options) {
        return __awaiter(this, void 0, void 0, function () {
            var errors, warnings, nodeKey, node, matchNodes, error_1;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        errors = [];
                        warnings = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        nodeKey = pattern.toString();
                        node = this.nodes[nodeKey];
                        matchNodes = node ? (_a = {}, _a[nodeKey] = node, _a) : this.nodes;
                        return [4, Promise.all(shared_1.reduce(matchNodes, function (buf, validator, path) {
                                if (shared_1.isFn(_this.matchStrategy)
                                    ? _this.matchStrategy(pattern, path)
                                    : pattern.match(path)) {
                                    return buf.concat(validator(options).then(function (result) {
                                        if (result.errors.length) {
                                            errors = errors.concat({
                                                path: path.toString(),
                                                messages: result.errors
                                            });
                                        }
                                        if (result.warnings.length) {
                                            warnings = warnings.concat({
                                                path: path.toString(),
                                                messages: result.warnings
                                            });
                                        }
                                    }));
                                }
                                return buf;
                            }, []))];
                    case 2:
                        _b.sent();
                        return [2, {
                                errors: errors,
                                warnings: warnings
                            }];
                    case 3:
                        error_1 = _b.sent();
                        shared_1.log.error(error_1);
                        return [2, {
                                errors: errors,
                                warnings: warnings
                            }];
                    case 4: return [2];
                }
            });
        });
    };
    FormValidator.registerRules = function (rules) {
        shared_1.each(rules, function (rule, key) {
            if (shared_1.isFn(rule)) {
                ValidatorRules[key] = rule;
            }
        });
    };
    FormValidator.registerFormats = function (formats) {
        shared_1.each(formats, function (pattern, key) {
            if (shared_1.isStr(pattern) || pattern instanceof RegExp) {
                ValidatorFormators[key] = new RegExp(pattern);
            }
        });
    };
    FormValidator.registerMTEngine = function (template) {
        if (shared_1.isFn(template)) {
            FormValidator.template = template;
        }
    };
    return FormValidator;
}());
exports.FormValidator = FormValidator;
FormValidator.registerFormats(formats_1.default);
FormValidator.registerRules(rules_1.default);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/validator/lib/validator.js
// module id = 4638
// module chunks = 0